<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">

        
        
        <Detail 
          :header="'Customer Details'" 
          :values="values" 
          :specialMessage="activeMessage"
          @edit="edit"
        />
        <TabMenu :model="nestedRouteItems" />
        <router-view v-if="customer" :customer="customer" />

        <!-- Dialog to Create & Edit a Customer -->
        <customerForm
          :customerToEdit="customer"
          :customerDialog="customerDialog"
          :disabledArr="disabledArr"
          @close="hideDialog"
          @saved="saved"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";

import Detail from "@/mbp/universalComponents/Detail.vue";
import customerForm from '../universalComponents/customer/customerForm'
import BreadcrumbRecordMixin from '../BreadcrumbRecordMixin'

export default {
  mixins: [BreadcrumbRecordMixin],
  components: {
    Detail,
    customerForm
  },
  data() {
    return {
      customerDialog: false,
      nestedRouteItems: [
        {
          label: "Info",
          icon: 'pi pi-info-circle',
          to: `/customers/${this.$route.params.custid}/detail`
        },
        {
          label: "Contacts",
          icon: 'pi pi-id-card',
          to: `/customers/${this.$route.params.custid}/contacts`
        },
        {
          label: "Linked Accounts",
          icon: 'pi pi-share-alt',
          to: `/customers/${this.$route.params.custid}/linkedaccounts`
        },
        {
          label: "Notes",
          icon: 'pi pi-align-justify',
          to: `/customers/${this.$route.params.custid}/notes`
        },
        {
          label: "Quotations",
          icon: 'pi pi-money-bill',
          to: `/customers/${this.$route.params.custid}/quotations`
        },
        {
          label: "Tasks & Events",
          icon: 'pi pi-calendar',
          to: `/customers/${this.$route.params.custid}/activities`
        },
        {
          label: "Attachments",
          icon: 'pi pi-file',
          to: `/customers/${this.$route.params.custid}/attachments`
        },
        {
          label: "Sales Stats",
          icon: 'pi pi-chart-line',
          to: `/customers/${this.$route.params.custid}/sales`
        },
        {
          label: "History",
          icon: 'pi pi-inbox',
          to: `/customers/${this.$route.params.custid}/history`,
        }
      ],
      customer: {},
      values: [],
      activeMessage: '',
      disabledArr: []
    };
  },
  customerService: null,
  created() {
    this.customerService = new CustomerService();
    this.setupFieldPermissions();
  },
  mounted() {
    this.getCustomerInfo()
  },
  computed: {
    myPermissions() {
      return this.$store.getters['auth/getUserPermissions']
    },
    breadcrumbRecordLabel() {
      return this.customer && this.customer.custName ? this.customer.custName : ''
    }
  },
  watch: {
    myPermissions(val) {
      if (val && val[0]) {
        this.setupFieldPermissions();
      }
    }
  },
  methods: {
    setupFieldPermissions() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'EditCustFields');
      if (permission) {
        if (permission.permissionLevel === 2) {
          this.disabledArr.push(...permission.permission.fields.split(','))
        } else if (permission.permissionLevel === 0) {
            this.disabledArr = [
              'custName',
              'address1',
              'address2',
              'address3',
              'address4',
              'postCode',
              'customerType',
              'phoneNo',
              'mobile',
              'email',
              'mainNotes',
              'showMsg',
              'tag',
              'website',
              'mainEmail',
              'faxNo',
              'salesExec',
              'parentFlag',
              'region',
              'keyContact',
              'custCode',
              'parentCustomer'
            ]
        }
        else if (permission.permissionLevel === 3) {
            this.disabledArr = []
        }
      }
    },
    getCustomerInfo() {
      this.customerService
        .getCustomerInfo(this.$route.params.custid)
        .then(data => {
          this.customer = data

          this.values = [
            {
              title: "Code:",
              description: this.customer ? this.customer.custCode : "",
            },
            {
              title: "Name:",
              description: this.customer ? this.customer.custName : "",
            },
            {
              title: "Status:",
              description: this.customer ? this.customer.status : "",
            },
            null
          ]

          // data.active === false ? this.activeMessage = 'Inactive' : this.activeMessage = ''
          this.activeMessage = data.active === false ? 'Inactive' : ''
        })
        .catch(err => {
          
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "customerInfo"'
          })
        })
    },
    saved({ customer, duplicates }) {
      
      this.customerDialog = false;
      this.getCustomerInfo()
    },
    hideDialog() {
      this.customerDialog = false;
    },
    edit() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'EditCustFields');
      if (permission) {
        if (permission.permissionLevel !== 0) {
          this.customerDialog = true;
        } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "You don't have permission to edit the customer",
              life: 5000,
            })
        }
      }
    }
  },
};
</script>
